import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

export { StyledTopContainer };
